import { render } from "./FooterButton.vue?vue&type=template&id=f7f16380"
import script from "./FooterButton.vue?vue&type=script&lang=js"
export * from "./FooterButton.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ricardo/Sites/customizer/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__